{{ 'dashboard.lockedtimeseries.removelock.description' | translate }}
@if (element?.length >= 1) {
  <ul class="flex flex-col gap-2 w-1/3">
    @for (el of element; track el) {
      <li class="text-sm flex-grow-0 bg-slate-200 text-theme-secondary px-2 py-1 rounded">{{ el.meteringPointIdentification }}</li>
    }
  </ul>
}
